<template>
  <div>
    <div class="env-switcher">
      <v-btn
        class="mx-2 rounded-circle"
        size="large"
        color="red"
        rounded
        @click="showDialog = true"
      >
        <v-icon class="icon">$iconGearConfig</v-icon>
      </v-btn>
    </div>

    <RightSideDialog
      v-model:show-right-dialog="showDialog"
      dialog-heading="Environment Switcher"
      class="custom-right-dialog"
    >
      <v-container fluid class="custom-container">
        <div>
          <v-radio-group v-model="radioGroup" class="mt-0 pt-0 v-input-radio item-radio">
            <v-radio
              v-for="(n, index) in ENV_OPTIONS"
              :key="index"
              :label="n.label"
              :value="n.value"
              color="primary"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="radioGroup.baseApiUrl"
            label="Base API URL"
            variant="outlined"
            :readonly="radioGroup.envKey !== 'custom'"
          ></v-text-field>

          <v-text-field
            v-model="radioGroup.baseApiRestaurantUrl"
            label="Base API Restaurant URL"
            variant="outlined"
            :readonly="radioGroup.envKey !== 'custom'"
          ></v-text-field>

          <v-text-field
            v-model="radioGroup.baseApiPriceEngineUrl"
            label="Base API Price Engine URL"
            variant="outlined"
            :readonly="radioGroup.envKey !== 'custom'"
          ></v-text-field>

          <v-text-field
            v-model="radioGroup.hhMenuApiUrl"
            label="HH Menu API URL"
            variant="outlined"
            :readonly="radioGroup.envKey !== 'custom'"
          ></v-text-field>

          <v-text-field
            v-model="radioGroup.chartUrl"
            label="Chart URL"
            variant="outlined"
            :readonly="radioGroup.envKey !== 'custom'"
          ></v-text-field>
        </div>
        <div>
          <v-btn block color="primary" @click="save">Save</v-btn>
        </div>
      </v-container>
    </RightSideDialog>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from "vue";
import { storageSwitcher, getStorageSwitcher, setStorageSwitcher } from "@/utils/storage.util";
import RightSideDialog from "@/components/dialogs/right-side-dialog/RightSideDialog.vue";

import {
  envBaseUrlApi,
  envBaseUrlApiRestaurant,
  envBaseUrlApiPriceEngine,
  envHHMenuApiUrl,
  envChartUrl,
  ENV_OPTIONS,
} from "@/config/env.config";

const showDialog = ref(false);
const radioGroup = ref({
  envKey: "env",
  baseApiUrl: envBaseUrlApi,
  baseApiRestaurantUrl: envBaseUrlApiRestaurant,
  baseApiPriceEngineUrl: envBaseUrlApiPriceEngine,
  hhMenuApiUrl: envHHMenuApiUrl,
  chartUrl: envChartUrl,
});

const fetchStorage = async () => {
  const envData = await getStorageSwitcher("env");
  if (envData) {
    radioGroup.value.envKey = envData.ENV_KEY;
    radioGroup.value.baseApiUrl = envData.APP_BASE_API_URL;
    radioGroup.value.baseApiRestaurantUrl = envData.APP_BASE_API_RESTAURANT_URL;
    radioGroup.value.baseApiPriceEngineUrl = envData.APP_BASE_API_PRICE_ENGINE_URL;
    radioGroup.value.hhMenuApiUrl = envData.APP_HH_MENU_API_URL;
    radioGroup.value.chartUrl = envData.APP_CHART_URL;

    if (envData.ENV_KEY === "custom") {
      ENV_OPTIONS[5].value.baseApiUrl = envData.APP_BASE_API_URL;
      ENV_OPTIONS[5].value.baseApiRestaurantUrl = envData.APP_BASE_API_RESTAURANT_URL;
      ENV_OPTIONS[5].value.baseApiPriceEngineUrl = envData.APP_BASE_API_PRICE_ENGINE_URL;
      ENV_OPTIONS[5].value.hhMenuApiUrl = envData.APP_HH_MENU_API_URL;
      ENV_OPTIONS[5].value.chartUrl = envData.APP_CHART_URL;
    }
  }
};

const save = async () => {
  await setStorageSwitcher(radioGroup.value);
  window.location.reload();
};

onBeforeMount(async () => {
  await storageSwitcher();
  await fetchStorage();
});
</script>

<style scoped lang="scss">
.env-switcher {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 99;

  .v-btn {
    min-width: 64px;
    width: 64px;
    height: 64px;

    .icon {
      width: 40px;
      height: 40px;
      transition: transform 0.3s ease;
    }
  }

  :hover {
    .icon {
      transform: rotate(90deg);
    }
  }
}

.custom-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 12px;
  overflow-y: auto;
}

.custom-right-dialog {
  justify-content: start;
}

:deep(.v-icon__component) {
  min-width: 40px;
  min-height: 40px;
}
</style>
